import { FormShell, RBButton } from '@scmlatam/web-ui';
import { useDeleteShift } from '../hooks/useFormDeleteShift';

interface DeleteShiftDialogProps {
    formProps: ReturnType<typeof useDeleteShift>;
}

const DeleteShiftDialog = ({ formProps }: DeleteShiftDialogProps) => {
    const { openForm, closeForm, submit } = formProps;

    return (
        <FormShell
            open={openForm}
            title={formProps.title}
            size="m"
            onClose={closeForm}
            loading={formProps.loading}
            footer={
                <div id="schedule-delete-shift-footer" className="flex flex-wrap items-center justify-end gap-3 p-3">
                    <RBButton id="schedule-delete-shift-cancel" variant="secondary" size="m" disabled={formProps.loading} onClick={closeForm}>
                        {formProps.t('delete_shift.buttons.cancel')}
                    </RBButton>
                    <RBButton id="schedule-delete-shift-delete" size="m" loading={formProps.loading} onClick={submit}>
                        {formProps.t('delete_shift.buttons.delete')}
                    </RBButton>
                </div>
            }
        >
            <div id="schedule-delete-shift-form" className="flex min-h-60 items-center">
                <p className="text-2xl">{formProps.t('delete_shift.fields.message')}</p>
            </div>
        </FormShell>
    );
};

export { DeleteShiftDialog };
